import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { api } from "@/lib/api";
import PinLock from "@/components/PinLock";
import Shell from "@/components/Shell";
import Dashboard from "@/pages/Dashboard";
import Backtest from "@/pages/Backtest";
import History from "@/pages/History";
import RunDetail from "@/pages/RunDetail";
import Settings from "@/pages/Settings";
import PnlCalendar from "@/pages/PnlCalendar";

function App() {
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    const lock = () => setAuthed(false);
    window.addEventListener("lvrc-lock", lock);
    if (!localStorage.getItem("lvrc_token")) setAuthed(false);
    else api.get("/auth/me").then(() => setAuthed(true)).catch(() => setAuthed(false));
    return () => window.removeEventListener("lvrc-lock", lock);
  }, []);

  return (
    <div className="dark min-h-screen bg-[#090D16] text-slate-200">
      <Toaster theme="dark" position="top-right" richColors />
      {authed === null && <div className="p-10 label-xs" data-testid="app-loading">Loading…</div>}
      {authed === false && <PinLock onUnlock={() => setAuthed(true)} />}
      {authed && (
        <BrowserRouter>
          <Shell onLock={() => { localStorage.removeItem("lvrc_token"); setAuthed(false); }}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/backtest" element={<Backtest />} />
              <Route path="/calendar" element={<PnlCalendar />} />
              <Route path="/history" element={<History />} />
              <Route path="/history/:id" element={<RunDetail />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Shell>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
